<template>
<v-container fluid>
  <div class="page-shell">
    <notification-dialog></notification-dialog>
    <filter-form-company/>
    <dialog-form-company v-if="canWrite"/>
    <v-card class="page-card">
      <v-toolbar color="primary" class="page-toolbar">
        <v-toolbar-title>Entidades Comerciales</v-toolbar-title>
        <v-btn v-if="canCreate" color="white" variant="flat" class="toolbar-add-button" @click="addCompany()">Agregar Entidad Comercial</v-btn>
      </v-toolbar>
      <div class="table-wrapper">
        <table-company/>
      </div>
    </v-card>
  </div>
</v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import FilterCompanyForm from './FilterCompanyForm'
import AddEditCompanyForm from './AddEditCompanyForm'
import CompanyTable from './CompanyTable'
import NotificationDialog from '../Common/NotificationDialog'

export default {
  name: 'Company',
  components: {
    'filter-form-company': FilterCompanyForm,
    'dialog-form-company': AddEditCompanyForm,
    'table-company': CompanyTable,
    'notification-dialog': NotificationDialog
  },
  computed: {
    ...mapGetters(['getNotifiDialog']),
    ...mapGetters('authModule', ['hasPermission']),
    canCreate () { return this.hasPermission('catalog.companies.create') },
    canWrite () { return this.canCreate || this.hasPermission('catalog.companies.update') }
  },

  methods: {
    addCompany () {
      this.$store.dispatch('companyModule/setDialogActived', true)
    }
  }
}
</script>
